import { concat, forEach } from "lodash";

function log()
{
    // console.log.apply( null, concat([ '---'], arguments ));
}

export const getTitleSuffixForRequestFilterStructure = ( filter ) =>
{
        let titleSuffix = '';
        {
            let filter_requestInfo = {
                accepted: {name: 'Přijatý'},
                closed: {name: 'Uzavřený'},
                dismissed: {name: 'Zamítnutý'},
                initial: {name: 'Čekající'},
                resolved: {name: 'Vyřešený'},
                resolving: {name: 'Řešený'}
            };
            let chosenCount = 0;
            let chosen = null;
            forEach( filter, ( isChosen, someRandomKey ) =>
            {
                log( {isChosen, someRandomKey, chosenCount, chosen});
                if( filter_requestInfo[ someRandomKey ] && isChosen )
                {
                    chosenCount++;
                    chosen = filter_requestInfo[ someRandomKey ];
                }
                log( {isChosen, someRandomKey, chosenCount, chosen});
            });

            if( chosenCount === 1 )
            {
                titleSuffix = `- ${chosen.name}`;
            }
            else
            {
                titleSuffix = '';
            }
        }

        return titleSuffix;
};



// WEBPACK FOOTER //
// ./src/Atollon/Requests.js